import { Alert, Box, Grid, Paper } from "@mui/material";
import SourcesChips from "@/components/VulnerabilityWatch/Sources/SourcesChips.tsx";
import SourcesSidebar from "@/components/VulnerabilityWatch/Sources/SourcesSidebar.tsx";
import SourcesTable from "@/components/VulnerabilityWatch/Sources/SourcesTable.tsx";
import SourcesToolbar from "@/components/VulnerabilityWatch/Sources/SourcesToolbar.tsx";
import { useSourcesFilters } from "@/hooks/useSourcesFilters.ts";
import { usePortalOverview, usePortalSources } from "@/hooks/useVulnerabilityWatch.ts";
import { readPortalWindow } from "@/utils/sourcesSidebar.ts";
import * as copy from "@/utils/vulnerabilityCopy.ts";

export default function SourcesTab() {
  const { filters, page, setFilters, setPage } = useSourcesFilters();
  const sources = usePortalSources(filters, page);
  const overview = usePortalOverview();
  const { windowDays, linesKnown } = readPortalWindow(overview.data);
  return (
    <Box>
      <SourcesChips filters={filters} windowDays={windowDays} onChange={setFilters} />
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, lg: 3 }}>
          <SourcesSidebar filters={filters} onChange={setFilters} overview={overview.data} windowDays={windowDays}
            yourProductKnown={sources.data?.your_product_known ?? false} />
        </Grid>
        <Grid size={{ xs: 12, lg: 9 }} sx={{ minWidth: 0 }}>
          <Paper variant="outlined" sx={{ overflow: "hidden" }}>
            <SourcesToolbar filters={filters} onChange={setFilters} page={page} onPage={setPage} data={sources.data}
              isFetching={sources.isFetching} />
            {sources.error ? (
              <Alert severity="error" sx={{ m: 2 }}>{copy.SOURCES_LOAD_FAILED}</Alert>
            ) : (
              <SourcesTable data={sources.data} isLoading={sources.isLoading} linesKnown={linesKnown} />
            )}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
